import { render, staticRenderFns } from "./CmsIndexSaveButton.vue?vue&type=template&id=648289da&scoped=true"
import script from "./CmsIndexSaveButton.vue?vue&type=script&lang=ts"
export * from "./CmsIndexSaveButton.vue?vue&type=script&lang=ts"
import style0 from "./CmsIndexSaveButton.vue?vue&type=style&index=0&id=648289da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648289da",
  null
  
)

export default component.exports